import React, { useEffect, useRef, memo } from 'react';
import { useTelegram } from '@/app/providers/TelegramProvider';

interface BackButtonProps {
  visible?: boolean;
  onClick?: () => void;
}

export const BackButton = memo(
  ({ visible = true, onClick }: BackButtonProps) => {
    const { webApp } = useTelegram();

    const onClickRef = useRef<BackButtonProps['onClick']>(undefined);
    const isShownRef = useRef(false);

    // Держим актуальный onClick без перерегистрации handler'а
    useEffect(() => {
      onClickRef.current = onClick;
    }, [onClick]);

    // Регистрируем один обработчик один раз
    useEffect(() => {
      if (!webApp?.BackButton) return;

      const handler = () => {
        onClickRef.current?.();
      };

      webApp.BackButton.onClick(handler);

      return () => {
        // Telegram API: offClick() без аргументов — снимает всех
        webApp.BackButton.offClick();
      };
    }, [webApp]);

    // Управляем видимостью отдельно и бережно
    useEffect(() => {
      if (!webApp?.BackButton) return;

      if (visible) {
        if (!isShownRef.current) {
          webApp.BackButton.show();
          isShownRef.current = true;
        }
      } else if (isShownRef.current) {
        webApp.BackButton.hide();
        isShownRef.current = false;
      }
    }, [visible, webApp]);

    // Прячем кнопку при размонтировании
    useEffect(() => {
      return () => {
        if (webApp?.BackButton && isShownRef.current) {
          webApp.BackButton.hide();
          isShownRef.current = false;
        }
      };
    }, [webApp]);

    return null;
  },
);
